const loginToken = localStorage.getItem("authToken");
export default loginToken;
